import './App.css';
import React, { useState, useEffect } from 'react';
import {HoraeDataGrande} from './DataEx.js'; 
import { useNavigate   } from "react-router-dom";
import {SvgTab01, SvgTab02, SvgTab03, SvgTab04,
  SvgTab05, SvgTab06, SvgTab07, SvgTab09, //SvgTab08,
  SvgTab10, SvgMov01, SvgMov02, SvgMov03,
  SvgMov04, SvgMov05, SvgLogin,
  SvgPDV,  SvgUser, SvgLic, SvgLogout} from './Svg.js';

  
function Login() {
  const [email, setEmail] = useState('');
  const [emailid, setEmailid] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate(); // Inicialize o hook
  //const [modulos, setModulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  
   
  let id = 1000154;
  useEffect(() => {
    const sessionStatus = sessionStorage.getItem('isLoggedIn');
    
    if (sessionStatus === 'true') {setIsLoggedIn(true); }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {

    }
  }, [isLoggedIn]);

  
  useEffect(() => {
    const getemailid = sessionStorage.getItem("emailid");
      fetch(`http://www.criar.com.br:3000/UsuarioModulos?id=${getemailid}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na resposta da API');
          }
          return response.json();
        })
        .then((data) => setClientes(data.ClienteModulos))
        .catch((error) => console.error('Erro ao buscar os dados:', error));
        //navigate(0); // fica piscando a tela
  }, [id]); 

  //navigate(0); // fica piscando a tela

  const handleSubmit = async (event) => {
    event.preventDefault(); // Evita o comportamento padrão do formulário
    try {
      const response = await fetch('http://www.criar.com.br:3000/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, emailid, password }), 
      });
      if (response.status === 200) {
        const data = await response.text();
        //alert(data);
        //alert(data+' - '+response);
        //if (data === "Sucesso!") {
          if (data.includes("Sucesso!")) {
          setIsLoggedIn(true);
          let wemailid =  data.replace(/\D/g, "");
          sessionStorage.setItem('isLoggedIn', 'true'); 
          sessionStorage.setItem('email', email); 
          sessionStorage.setItem('emailid', wemailid); 
         } else {
        alert(data);
      }
    }
    } catch (error) {
      alert('Erro na autenticação:', error);
    }
  };
  
  const handleLogout = () => {
    setIsLoggedIn(false);
    sessionStorage.removeItem('isLoggedIn'); 
    sessionStorage.removeItem('email'); 
    sessionStorage.removeItem('emailid'); 
    setEmail('');
    setEmailid('');
    setPassword('');
  };

  const handle01 = () => {
    navigate("/FormUsu");    
  };
  
  const handle02 = () => {
    navigate("/FormCli");    
  };

  const tabtpo = () => {    navigate("/TpoGrid");      };
  const tabpro = () => {    navigate("/ProGrid");      };
  const tabpag = () => {    navigate("/PagGrid");      };
  const tabacrdes = () => { navigate("/AcrDesGrid");      };
  const tabfun = () => {    navigate("/FunGrid");      };
  const tabcc  = () => {    navigate("/CcGrid");      };
  const tabpla = () => {    navigate("/PlaGrid");      };
  const tabfre = () => {    navigate("/FreGrid");      };
  const tabanu = () => {    navigate("/AnuGrid");      };
  const pdv    = () => {    navigate("/Pdv");      };

  return (
    <div>
      {isLoggedIn ? (
        <div class = "recipiente">
          <div id="titulo">
              <br/>
              <br/>
              <h2>Área Restriata</h2> 
              <h5>Bem-vindo, {sessionStorage.getItem("email")} </h5>


            


              
    <div>
        <div>
        <br/>

          <ul>
<table class="tableGrid2">
        <tbody>
          {clientes.map((ClienteModulos) => (
            <tr key={ClienteModulos.Id}>
              <td>
                    
                    <div>
                      {ClienteModulos.Modulo === "Adm" ?        <><button onClick={tabtpo} class="botaocinsa botao9"><SvgTab01/><br/>Tipos de  <br/>Operações</button>&nbsp;</>: null}
                      {ClienteModulos.Modulo === "Retaguarda" ? <><button onClick={tabpro} class="botaocinsa botao9"><SvgTab02/><br/>Produtos e <br/>Serviços</button>&nbsp;</>: null}
                      {ClienteModulos.Modulo === "Retaguarda" ? <><button onClick={tabpag} class="botaocinsa botao9"><SvgTab03/><br/>Tipos de <br/>Pagamentos</button>&nbsp;</>: null}
                      {ClienteModulos.Modulo === "Retaguarda" ? <><button onClick={tabacrdes} class="botaocinsa botao9"><SvgTab04/><br/>Acrescimos e <br/>Descontos</button></>: null}
                      {ClienteModulos.Modulo === "Retaguarda" ? <><button onClick={tabfun} class="botaocinsa botao9"><SvgTab05/><br/><br/>Funcionarios</button></>: null}
                      {ClienteModulos.Modulo === "Adm" ?        <><button onClick={tabcc} class="botaocinsa botao9"><SvgTab06/><br/><br/>Contas</button>&nbsp;</>: null}
                      {ClienteModulos.Modulo === "Adm" ?        <><button onClick={tabpla} class="botaocinsa botao9"><SvgTab07/><br/>Plano de <br/>Contas</button>&nbsp;</>: null}
                      {ClienteModulos.Modulo === "Adm" ?        <><button onClick={tabfre} class="botaocinsa botao9"><SvgTab09/><br/><br/>Frete</button>&nbsp;</>: null}
                      {ClienteModulos.Modulo === "Adm" ? <><button onClick={tabanu} class="botaocinsa botao9"><SvgTab10/><br/><br/>Anúncios</button></>: null}
                    </div> 
                    {ClienteModulos.Modulo === "Adm" ? 
                    <div>
                      <button onClick={handle02} class="botaocinsa botao9"><SvgMov01/><br/><br/>Vendas</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><SvgMov02/><br/><br/>Compras</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><SvgMov04/><br/><br/>Cobrança</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><SvgMov03/><br/><br/>Financeiro</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><SvgMov05/><br/><br/>Fechamento</button>&nbsp;
                    </div> : null}
                    {ClienteModulos.Modulo === "PDV" ? 
                    <div>
                      <button onClick={pdv} class="botaocinsa botao17 "><SvgPDV/><br/><br/>PDV<br/>Frente de Caixa</button>&nbsp;
                    </div> : null}
                    {ClienteModulos.Modulo === "Emissores Fiscais" ? 
                    <div>
                      <button onClick={handle02} class="botaocinsa botao9"><br/>SAT</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/>NFC-e</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/>NF-e</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/>RPS/NFS-e</button>&nbsp;
                    </div> : null}
                    {ClienteModulos.Modulo === "Complementos" ? 
                    <div>
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Cadastro</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>CEP</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>SiTef</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Micro Terminais</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Consutla Preço</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Envia</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Identificador</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Paineis</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Produção</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Cozinha</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/><br/>Balança</button>&nbsp;
                    </div> : null}
                    {ClienteModulos.Modulo === "Controles" ? 
                    <div>
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Controle de <br/>Estacionamento</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Controle de <br/>Lava Rapido</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Controle de  <br/>Posto de Abastecimento</button>&nbsp;
                    </div> : null}
                    {ClienteModulos.Modulo === "Totens" ? 
                    <div>
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Totem de<br/>Entrada</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Totem de<br/>Saida</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Totem de<br/>Pagamento</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Totem de<br/>Balança</button>&nbsp;
                      <button onClick={handle02} class="botaocinsa botao9"><br/><br/>Totem de<br/>Bebidas</button>&nbsp;
                    </div> : null}
                    {ClienteModulos.Modulo === "Login" ?
                    <div>
            <button onClick={handle01} class="botaocinsa botao9"><SvgUser/><br/>Usuários</button>&nbsp;
            <button onClick={handle02} class="botaocinsa botao9"><SvgLic/><br/>Licenças</button>&nbsp;

                    </div> : null}


              </td>
              </tr>
          ))}

<tr>
<td>
<br/>
<button onClick={handleLogout} class="botaocinsa botao9"><SvgLogout/><br/>Sair </button>
<br/>
</td>
</tr>
        </tbody>
      </table>            
      
          </ul>
        </div>
    </div>
  </div>
            <br/>
            {sessionStorage.getItem("email")==="marcos@criar.com.br" ? (
              <>
              </>
              ):(
              <>  
              </>
              )
            }


        


          </div>
      ) : (
        
<div class="areabox">
<div class="DateeHora"><HoraeDataGrande/> </div>
  <h1>Área Restrita</h1>
  <div class='row'>
    <div class='col-pl'>
    </div>
    <div class='col-8'>
      <div class='card1'>
        <h2> Acesso ao sistema</h2>
        <form onSubmit={handleSubmit}>
        <div class="form-group">
        <label for="email" class="form-control">Email:</label><br/>
        <input type="email" id="email" placeholder="Entre com o email" value={email} onChange={(e) => setEmail(e.target.value)} required 
          size="28"  class="form-controli"   name="email" /><br/><br/>
        <label for="password" class="form-control">Senha:</label><br/>
        <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required
        size="15"  class="form-controli" /><br/>
        <br/><a href="/LoginEsquceuSenha"   class="form-control">Esqueceu a senha?</a><br/><br/>
        <button type="submit" class="botaocinsa"><SvgLogin/><br/>Entrar</button><br/><br/>
        <a href="/LoginSemCadastro"   class="form-control">Não tenho Cadastro (Novo Cadastro)</a><br/><br/>
        </div>
        </form>
      </div>
    </div>
  </div>
</div>  

)}
    </div>
  );
}

export default Login;